import {Injectable} from '@angular/core';
import {plainToInstance} from 'class-transformer';
import {ClassificatorModel} from './models/classificator.model';
import {ClassificatorsQuery, ClassificatorValuesQuery, MesApiService, ClassificatorValueQuery} from 'common-shared';
import {map} from 'rxjs/operators';
import {Observable} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ClassificatorValueService extends MesApiService {
  constructor(private classificatorsQuery: ClassificatorsQuery, private classificatorValuesQuery: ClassificatorValuesQuery) {
    super('Classificator');
  }

  getAll$: Observable<ClassificatorValueQuery[]> = this.classificatorValuesQuery.selectAll();

  loadOne(id: string) {
    return this.getSingle<ClassificatorModel>({
      id: id
    }).pipe(map(value => {
      return plainToInstance(ClassificatorModel, value.data);
    }));
  }

  addNew(classificatorModel: ClassificatorModel): Observable<ClassificatorModel> {
    return this.add<ClassificatorModel>(classificatorModel, {
      action: 'Post'
    }).pipe(map(value => {
      this.classificatorsQuery.loadAll(value.data.Id);
      return plainToInstance(ClassificatorModel, value.data);
    }));
  }

  save(classificatorModel: ClassificatorModel): Observable<ClassificatorModel> {
    classificatorModel.Values = classificatorModel.Values.filter(clv => !clv.isEmpty());
    return this.update<ClassificatorModel>(classificatorModel.Id, classificatorModel).pipe(map(value => {
      this.classificatorsQuery.loadAll(value.data.Id);
      return plainToInstance(ClassificatorModel, value.data);
    }));
  }

  remove(classificatorModel: ClassificatorModel): Observable<ClassificatorModel> {
    return this.delete<ClassificatorModel>(classificatorModel.Id).pipe(map(value => {
      classificatorModel.Values.map(value1 => this.classificatorValuesQuery.remove(value1.Id));
      this.classificatorsQuery.remove(value.data.Id);
      return plainToInstance(ClassificatorModel, value.data);
    }));
  }
}
